import React, { useState } from 'react';
import '../../styles/Common/EmailCard.css';
import { Modal, Button, Spinner } from 'react-bootstrap';
import axiosInstance from '../../utils/api';
import EmailPreviewFrame from '../Common/EmailPreviewFrame';

const Card = ({ title, name, description, handleUseTemplate, previewUrl, emailId, image, previewImage , templateName}) => {
  const [isPreviewVisible, setIsPreviewVisible] = useState(false);
  const [previewHtml, setPreviewHtml] = useState('');
  const [previewCss, setPreviewCss] = useState('');
  const [loadingPreview, setLoadingPreview] = useState(false);
  const [error, setError] = useState('');
  const [previewMode, setPreviewMode] = useState('desktop');

  const handlePreview = async () => {
    setIsPreviewVisible(true);
    setLoadingPreview(true);
    setError('');

    try {
      const response = await axiosInstance.get(`/api/v1/fetch_email_html?email_id=${emailId}`);
      const html = response.data?.data?.html || "<p>No HTML content found</p>";
      const css = response.data?.data?.css || "";
      setPreviewHtml(html);
    setPreviewCss(css);
    } catch (err) {
      setError("Failed to load preview.");
    } finally {
      setLoadingPreview(false);
    }
  };

  const handleClosePreview = () => {
    setIsPreviewVisible(false);
    setPreviewHtml('');
    setPreviewCss('');
  };

  return (
    <>
      <div className="template-card">
       
        <h3 className="card-title">{name}</h3>
        <p className="card-description">{description}</p>
        <hr className='card-divider' />
        <div className="cont d-flex justify-content-center align-items-center">
          <button className="use-template-btn" onClick={handleUseTemplate}>
            Use template
          </button>
          <button className="use-template-btn" onClick={handlePreview}>
            Preview
          </button>
        </div>
      </div>

      <Modal
        size="lg"
        show={isPreviewVisible}
        onHide={handleClosePreview}
        centered
        scrollable
      >
        <Modal.Header closeButton>
          <Modal.Title>Preview: {name}</Modal.Title>
        </Modal.Header>

        <Modal.Body>
          {loadingPreview ? (
            <div className="d-flex justify-content-center align-items-center" style={{ minHeight: "200px" }}>
              <Spinner animation="border" />
            </div>
          ) : error ? (
            <p className="text-danger">{error}</p>
          ) : (
            <>
              <div className="d-flex justify-content-end mb-3">
                <Button
                  variant={previewMode === "desktop" ? "dark" : "outline-dark"}
                  className="me-2"
                  onClick={() => setPreviewMode("desktop")}
                >
                  Desktop
                </Button>
                <Button
                  variant={previewMode === "mobile" ? "dark" : "outline-dark"}
                  onClick={() => setPreviewMode("mobile")}
                >
                  Mobile
                </Button>
              </div>

              <EmailPreviewFrame
                htmlContent={previewHtml}
                cssContent={previewCss}
                previewMode={previewMode}
              />
            </>
          )}
        </Modal.Body>

        <Modal.Footer>
          <Button variant="secondary" onClick={handleClosePreview}>
            Close
          </Button>
        </Modal.Footer>
      </Modal>
    </>
  );
};

export default Card;
